// src/components/FloatingDiagnosticButton/FloatingDiagnosticButton.tsx
import React, { useState } from "react";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import ChatBot from "assets/lottie/Detecting your beautiful face.json";
import "./FloatingDiagnosticButton.scss";

interface FloatingDiagnosticButtonProps {
  onClick: () => void;
}

const FloatingDiagnosticButton: React.FC<FloatingDiagnosticButtonProps> = ({ onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      className="floating-diagnostic-btn"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{
        delay: 0.5,
        type: "spring",
        stiffness: 260,
        damping: 20
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Hover label - positioned outside the button */}
      {isHovered && (
        <motion.div
          className="btn-label"
          initial={{ opacity: 0, x: 10 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 10 }}
          transition={{ duration: 0.2 }}
        >
          Diagnostic d'usurpation
        </motion.div>
      )}

      <motion.button
        className="btn-main"
        onClick={onClick}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        aria-label="Ouvrir le diagnostic d'usurpation"
      >
        <div className="btn-icon">
          <Lottie
            animationData={ChatBot}
            loop={true}
            autoplay={true}
            style={{ width: 100, height: 110 }}
          />
        </div>
      </motion.button>

      {/* Optional: Pulsing effect */}
      <div className="pulse-ring"></div>
    </motion.div>
  );
};

export default FloatingDiagnosticButton;